/**
 * External dependencies
 */
import { combineReducers } from 'redux';

import id from './id';
import primaryPaymentSourceId from './primary-payment-source-id';


export default combineReducers({
    id,
    primaryPaymentSourceId
});